
//video
var $videoPlay = $('.videoPlay');

if($videoPlay.length){
	
	$videoPlay.click( function(e) {
		e.preventDefault();
		
		var videoSource = $(this).data('src'),
			$this = $(this);
	
		$this.fadeOut()
		$this.next('.cbVideoCursor').fadeOut();
		$this.prev('iframe').attr('src', videoSource);
	
	});

}




$('.cbCarousel').each( function( i, container ) {
	
	var $container = $(container);
	
	var $cbCarousel = $container.flickity({
		wrapAround: true,	 
		autoPlay: false,
		pageDots: false,
		prevNextButtons: false,
		setGallerySize: true,
		cellSelector: '.cbCarouselSlide',
		cellAlign: 'center',
		lazyLoad: 1
	});
	
	var $cbOverlay = $container.find('.cbCarouselOverlay');
	
	$cbCarousel.on( 'change.flickity', function( ) {
		  $cbOverlay.animate({"opacity":0}, 300, function() {
	    	$cbOverlay.remove();
	  	});
	});
					
					

	var $previousButton = $container.find('.cbCarouselNav.previous');
	
	$previousButton.on('click', function(e) {
		e.preventDefault();	
		$cbCarousel.flickity('previous');
		$cbCarousel.flickity('stopPlayer');
	});
	
	var $nextButton = $container.find('.cbCarouselNav.next');
	
	$nextButton.on('click', function(e) {
		e.preventDefault();	
		$cbCarousel.flickity('next');
		$cbCarousel.flickity('stopPlayer');
	});


});




